import { FC, ReactNode } from 'react'
import { useGameStore } from '@/store'

interface Props {
  children: ReactNode
  enabled?: boolean
}

export const CRTEffect: FC<Props> = ({ children, enabled: propEnabled }) => {
  const storeEnabled = useGameStore((state) => state.crtEffectEnabled)
  const enabled = propEnabled ?? storeEnabled

  if (!enabled) {
    return <>{children}</>
  }

  return (
    <div className="crt-container relative min-h-screen overflow-hidden">
      {/* Main content */}
      <div className="relative z-10">{children}</div>

      {/* Scanline overlay */}
      <div
        className="pointer-events-none fixed inset-0 z-20"
        style={{
          background:
            'repeating-linear-gradient(0deg, transparent, transparent 1px, rgba(0, 0, 0, 0.1) 1px, rgba(0, 0, 0, 0.1) 2px)',
          backgroundSize: '100% 2px',
        }}
      />

      {/* Vignette effect */}
      <div
        className="pointer-events-none fixed inset-0 z-20"
        style={{
          background:
            'radial-gradient(ellipse at center, transparent 50%, rgba(0, 0, 0, 0.4) 100%)',
        }}
      />

      {/* Subtle flicker animation */}
      <style>{`
        .crt-container {
          animation: crt-flicker 0.15s infinite;
        }

        @keyframes crt-flicker {
          0% { opacity: 0.97; }
          50% { opacity: 1; }
          100% { opacity: 0.98; }
        }
      `}</style>
    </div>
  )
}
